import React from 'react';
import "./home-component.scss";
import { Constants, ImageConstants } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source'
import LogIn from '../login/login';
import Loading from '../common/loading/loading';
import SessionCache from '../routes/session-cache';
import Path from '../routes/routes-path';
import CommonUtils from '../../utility/common-utilities';
import LayoutShared from '../common/layout-shared/layout-shared';
import CommonApi from '../../apis/common';

class HomeComponent extends React.Component {

    state = {
        activeTabIndex: 0,
        classDropdownData: null,
        sectionDropdownData: null,
        schoolDropdownData: null,
        isSignUpfailed: false,
        isEmailAlreadyRegistered: false,
        isLoginFailed: false,
        loading: false,
        signUpEmail: null
    }

    tabs = [
        { name: 'Teacher Login' },
    ];

    constructor(props) {
        super(props)
        this.layoutShared = LayoutShared.getLayout()
        console.log(this.layoutShared)
        // CommonUtils.refreshInternetStatus();
        if (window.AndroidClicker) {
            if (CommonUtils.isOnline()) {
                this.getCountryCode()
            }
        }
    }






    componentDidMount() {
        if (window.electron) {
            this.resetZoom()
        }
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
    }


    getCountryCode(payload = {}) {
        CommonApi.getCountryCode(payload).then((response) => {
            let data = response.response
            console.log(data.length)
        }).catch((err) => {
            CommonUtils.setOffline()
            this.setState({ loading: true }, () => {
                setTimeout(() => {
                    this.setState({ loading: false })
                }, 200)
            })
            // alert("Error while fetching country code. Please try again later.");
            // console.log(err)
        })
    }



    componentWillUnmount() {
        // Remove event listeners when the component unmounts
        console.log('component unmount called from login component')
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    }

    updateOnlineStatus(e) {
        // Update the state with the current online status
        console.log('update online status called from login component', navigator.onLine)
        if (window.electron) {
            window.location.reload();
        }

        if(window.AndroidClicker) {
            this.getCountryCode()
        }
    }


    resetZoom() {
        window.electron.ipcRenderer.send('reset-zoom', ['ping'])
    }


    goToMenu() {
        console.log('go to menu')
        let user = SessionCache.getUser()
        if (user.isSuperAdmin && !user.schoolInfo?.schoolCode) {
            this.props.history.replace(Path.SCHOOLS)
        } else {
            console.log('heee', this.props.history)
            this.props.history.replace(Path.DASHBOARD)
        }
    }

    register = () => {
        this.props.history.replace(Path.SIGNUP)
    }

    forgotPassword = () => {
        this.props.history.push(Path.FORGOT_PASSWORD)
    }

    closeElectronApp() {
        if (window.electron) {
            window.electron.ipcRenderer.send('close-app', ['ping'])
        } else if (
            window.AndroidClicker &&
            window.AndroidClicker.closeApp
        ) {
            window.AndroidClicker.closeApp();
        }
    }

    render() {

        return (
            <>
                {this.state.loading ? <Loading />
                    :
                    <div className="container-fluid home-component" >
                        <div className='header row no-gutters'>
                            <div className="col-6"> <img alt="" className="logo" src={getImageSource(ImageConstants.CW_LOGO)} /></div>
                            <div className="col-6 d-flex justify-content-end align-items-center">
                                <span>
                                    Version : {Constants.ELECTRON_VERSION} - {CommonUtils.isOnline() ? 'Online' : 'Offline'}
                                </span>

                                {Constants.ELECTRON_BUILD && (
                                    <button
                                        className="btn btn-danger btn-sm ml-2"
                                        onClick={() => this.closeElectronApp()}
                                    >
                                        Close
                                    </button>
                                )}
                            </div>

                            {/* {
                                    Constants.ELECTRON_BUILD ?
                                        <img className="close-icon ml-2 cursor-pointer"
                                            onClick={() => this.closeElectronApp()}
                                            src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                                        :
                                        <></>
                                } */}




                        </div>

                        <div className='row'>
                            <div className="col">
                                {/* <p className='slogan-text'>{Constants.SLOGAN}</p> */}
                            </div>
                            <div className="col pt-5 mt-5">
                                <div className='row center-box tab-max-width'>
                                    {this.tabs.map((tab, index) => (
                                        <div className={`col pl-4 text-left center-box`}>
                                            <span onClick={() => { this.setState({ activeTabIndex: index }) }} className={`tab-name ${this.state.activeTabIndex == index ? 'tab-name-active' : ''}`}>{tab.name}</span></div>
                                    ))}
                                </div>

                                <div className="row center-box p-1 mt-1">
                                    {/* <div className='container-1'>
                                    <div className='containter-item'>
                                        <p className='slogan-text-signup'>
                                            The Countingwell Maths Olympiad is Live! Access to this page will be back after completion of the Olympiad
                                            <h4><strong> {this.state.eventName}</strong></h4>
                                        </p>
                                    </div>
                                    <div className='containter-item'>
                                        <button className='btn1'>
                                            <a className='slogan-text-signup1' href='https://countingwell.com'>
                                                Back
                                            </a>
                                        </button>

                                    </div>
                                </div> */}
                                    {
                                        this.state.activeTabIndex == Constants.ACTIVE_TAB_LOGIN &&
                                        <LogIn
                                            isLoginFailed={this.state.isLoginFailed}
                                            delegate={this}
                                            signUpEmail={this.state.signUpEmail}
                                            clickSignup={this.register}
                                        ></LogIn>
                                    }

                                    {/* {this.state.activeTabIndex == Constants.ACTIVE_TAB_SIGN_UP &&
                                    this.state.classDropdownData &&
                                    this.state.schoolDropdownData &&
                                    this.state.sectionDropdownData && <SignUp
                                        class={this.state.classDropdownData}
                                        school={this.state.schoolDropdownData}
                                        section={this.state.sectionDropdownData}
                                        isSignUpfailed={this.state.isSignUpfailed}
                                        isEmailAlreadyRegistered={this.state.isEmailAlreadyRegistered}
                                        delegate={this}
                                    ></SignUp>} */}

                                </div>
                            </div>
                        </div>

                    </div>
                }
            </>
        );
    }
}

export default HomeComponent;